import { render } from "./MeuNegocio.vue?vue&type=template&id=bb9f81d6&ts=true"
import script from "./MeuNegocio.vue?vue&type=script&lang=ts"
export * from "./MeuNegocio.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__